import { useIntl } from "react-intl";
import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";
import { spacing } from "src/design-system/tokens/spacing";
import { tw } from "src/design-system/tw";
import { Skeleton } from "../../../components/Skeleton/Skeleton";
import { messages } from "./UserDetails.messages";

export function UserDetailsLoading() {
  const intl = useIntl();
  const { isMobile } = useScreenMinWidth();

  return (
    <div className="relative flex flex-col items-center lg:items-start">
      <div className="mb-6 h-18 w-18 overflow-hidden rounded-full lg:h-14 lg:w-14">
        <Skeleton height="100%" />
      </div>
      <Skeleton
        height={isMobile ? 29 : 24 + 8}
        width="100%"
        margin={`0 0 ${isMobile ? spacing.md : spacing.sm}`}
        padding={isMobile ? `0 ${spacing.xl}` : `0 0 ${spacing.md} 0`}
      />
      <Skeleton
        height={18}
        width="100%"
        margin={`0 0 ${spacing.xxl}`}
        padding={`0 ${isMobile ? spacing.lg : 0}`}
      />
      <Skeleton
        height={isMobile ? 18 : 22}
        width={170}
        margin={`0 0 ${spacing.xxl}`}
      />
      {!isMobile && (
        <Skeleton height={1} width="100%" margin={`0 0 ${spacing.xl}`} />
      )}
      <div className="flex w-full flex-col items-center px-4 py-2">
        <Skeleton height={isMobile ? 48 : 24} width={isMobile ? "100%" : 170} />
      </div>
      <p
        className={tw(
          "absolute bottom-1/2 left-1/2 flex h-34 w-66",
          "-translate-x-1/2 translate-y-1/2",
          "flex-col items-center justify-center",
          "rounded-md border border-border-secondary bg-fill-solid",
          "text-center text-heading-md font-semibold",
        )}
      >
        {intl.formatMessage(messages.loadingMessage, {
          lineBreaker: <br />,
        })}
      </p>
    </div>
  );
}
